/* Immediate local photo preview; AI controls appear only with a configured service. */
(function () {
  if (window.__pppPhotoPreview) return;
  window.__pppPhotoPreview = true;
  var current = null, pending = null, blob = null, timer = null, polling = false;
  var lastSignature = '', widget = null, challenge = '', panel = null, uploadBaseline = '';
  var visitor;
  try {
    visitor = sessionStorage.getItem('ppp-preview-visitor');
    if (!visitor) { visitor = crypto.randomUUID(); sessionStorage.setItem('ppp-preview-visitor', visitor); }
  } catch (_) { visitor = crypto.randomUUID(); }
  function box() { return document.querySelector('[data-ppp-format-preview]'); }
  function choice(name, fallback) {
    var el = document.querySelector('.product-details input[data-option-name="' + name + '"]:checked');
    return el ? el.value : fallback;
  }
  function state() {
    var el = box(); if (!el) return null;
    var photos = Array.from(document.querySelectorAll('input[name^="properties["]'))
      .filter(function (i) { return /photo|upload/i.test(i.name) && /^https:\/\/cdn\.tigren\.com\/uploads\//.test(i.value); })
      .sort(function (a,b) { return (Number(a.name.match(/\d+/)?.[0]) || 1) - (Number(b.name.match(/\d+/)?.[0]) || 1); })
      .map(function (i) { return i.value; });
    var petsEl = document.querySelector('input[name="properties[Number of pets]"]');
    var pets = Number((petsEl && petsEl.value.match(/^\d+/) || ['1'])[0]);
    return {handle: el.dataset.productHandle, style: choice(el.dataset.styleName, el.dataset.styleInitial),
      pets: pets, photos: photos.slice(0,pets), format: choice(el.dataset.formatName, el.dataset.formatInitial)};
  }
  function signature(s) { return JSON.stringify([s.handle,s.style,s.pets,s.photos]); }
  function formatKey(format) {
    if (/digital/i.test(format)) return 'digital';
    if (/canvas/i.test(format)) return /12/.test(format) ? 'canvas12' : 'canvas8';
    return /\ba3\b/i.test(format) ? 'a3' : 'a4';
  }
  function setToken(token) {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      var input = form.querySelector('input[name="properties[_ppp_preview_token]"]');
      if (!token) { if (input) input.remove(); return; }
      if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = 'properties[_ppp_preview_token]'; form.appendChild(input); }
      input.value = token;
    });
  }
  function status(text) {
    if (panel && panel.querySelector('[data-preview-status]').textContent !== text)
      panel.querySelector('[data-preview-status]').textContent = text;
  }
  function remember(job) {
    try { if (job) sessionStorage.setItem('ppp-preview-job',JSON.stringify(Object.assign({},job,{expires:Date.now()+7*86400000})));
      else sessionStorage.removeItem('ppp-preview-job'); } catch (_) {}
  }
  function render() {
    var el = box(), s = state(); if (!el || !s) return;
    var sig = signature(s);
    if (current && current.signature !== sig) { current = null; setToken(''); }
    if (pending && pending.signature !== sig) { pending = null; clearTimeout(timer); polling = false; }
    if (blob && JSON.stringify(s.photos) !== uploadBaseline && s.photos.length) { URL.revokeObjectURL(blob); blob=null; }
    var artwork = current && current.images[formatKey(s.format)];
    var src = artwork || blob || s.photos[0] || '';
    var note = artwork ? 'Your saved portrait. This artwork will be used for your order; the preview watermark is removed.' :
      (s.pets > 1 ? 'Your first pet’s photo in this format. This is a photo layout, not the finished group portrait.' :
      'Your photo in this format. This is a photo layout, not the finished AI portrait.');
    if (el.dataset.personalizedImage !== src || el.dataset.personalizedNote !== note) {
      el.dataset.personalizedImage = src; el.dataset.personalizedNote = note;
      document.dispatchEvent(new Event('ppp:preview-update'));
    }
    setToken(current ? current.token : '');
    if (panel) {
      var ready = !blob && s.photos.length === s.pets && !/^Any\b/i.test(s.style);
      panel.querySelector('button').disabled = !!pending || !!current || !ready || !challenge;
      if (!pending && !current && sig !== lastSignature)
        status(ready ? 'Generate one free portrait preview. It can take a minute or more. Changing frames afterwards is immediate.' : 'Choose a single style and upload one photo per pet.');
    }
    lastSignature = sig;
  }
  async function request(url, options) {
    var response = await fetch(url, Object.assign({signal: AbortSignal.timeout(15000),credentials:'omit'},options));
    var data = await response.json();
    if (!response.ok) { var error=new Error(typeof data.detail === 'string' ? data.detail : 'The preview service is unavailable.');error.status=response.status;throw error; }
    return data;
  }
  async function poll() {
    if (!pending || !pending.id || polling) return;
    polling = true;
    var job = pending;
    try {
      var data = await request(job.base + '/v1/previews/' + job.id);
      if (pending !== job) return;
      if (data.status === 'ready') {
        var images = {};
        Object.keys(data.images).forEach(function (k) { images[k] = job.base + data.images[k]; });
        current = {signature:job.signature,token:job.token,images:images}; pending = null;
        // Warm every crop once. Frame changes only change the display, never the artwork.
        Object.values(images).forEach(function (url) { var img = new Image(); img.src = url; });
        status('Your portrait is ready. Choose a format, then add it to your cart.');
      } else if (data.status === 'failed') { pending = null; remember(null); status(data.message); }
      else {
        status('Creating your portrait… ' + data.seconds + ' seconds. You can keep choosing a frame.');
        timer = setTimeout(poll, document.hidden ? 8000 : 2000);
      }
    } catch (error) {
      if (error.status===404 || error.status===410) { pending=null;remember(null);status('This preview has expired. Please contact the shop if you already ordered it.'); }
      else { status('Still checking your portrait. Your generation will not be restarted.'); timer = setTimeout(poll, 8000); }
    } finally { polling = false; render(); }
  }
  async function generate() {
    var s = state(), el = box(); if (!s || !challenge || pending || current) return;
    var base = el.dataset.previewService.replace(/\/$/,'');
    panel.querySelector('button').disabled = true;
    var submitted = signature(s);
    // Reserve UI immediately to prevent double clicks or another request during a slow response.
    pending = {signature:submitted,base:base,id:null};
    status('Starting your portrait…');
    try {
      var data = await request(base+'/v1/previews',{method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify(Object.assign({},s,{visitor:visitor,challenge:challenge}))});
      if (!state() || signature(state()) !== submitted) { pending=null; return; }
      pending = {signature:submitted,base:base,id:data.id,token:data.token}; remember(pending);poll();
    } catch (error) { pending=null; status(error.message + ' You can still order normally.'); }
    finally { challenge=''; if (window.turnstile && widget !== null) window.turnstile.reset(widget); render(); }
  }
  function init() {
    var el = box(); if (!el) return;
    if (panel && !panel.isConnected) { panel=null;widget=null;challenge=''; }
    if (el.dataset.previewService && el.dataset.previewSitekey && !panel) {
      var url; try { url = new URL(el.dataset.previewService); } catch (_) { return; }
      if (url.protocol !== 'https:') return;
      panel = document.createElement('div'); panel.className='ppp-preview-controls';
      panel.innerHTML='<p data-preview-status role="status">Upload your photo to preview.</p><div data-preview-challenge></div><button type="button" class="ppp-btn ppp-btn--gold" disabled>Generate my portrait preview</button>';
      el.appendChild(panel); panel.querySelector('button').addEventListener('click',generate);
      var script = document.createElement('script'); script.src='https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'; script.async=true;
      script.onload=function () { widget=window.turnstile.render(panel.querySelector('[data-preview-challenge]'),{
        sitekey:el.dataset.previewSitekey,action:'portrait_preview',theme:'dark',
        callback:function (token) { challenge=token;render(); },'expired-callback':function () { challenge='';render(); }
      }); }; document.head.appendChild(script);
    }
    render();
    if (!blob && !pending && !current && el.dataset.previewService) {
      try {
        var saved=JSON.parse(sessionStorage.getItem('ppp-preview-job') || 'null');
        if (saved && saved.expires>Date.now() && saved.signature===signature(state()) && saved.base===el.dataset.previewService.replace(/\/$/,'')) {
          pending=saved;poll();
        }
      } catch (_) {}
    }
  }
  document.addEventListener('change',function (event) {
    var input=event.target;
    if (input.matches('input[type="file"]') && input.closest('.easify-product-options')) {
      current=null;pending=null;setToken('');clearTimeout(timer);
      uploadBaseline=JSON.stringify(state()?.photos || []);
      if (blob) URL.revokeObjectURL(blob);
      blob=input.files && input.files[0] ? URL.createObjectURL(input.files[0]) : null;
      // Local image appears before Easify finishes uploading it.
      var el=box();if (el && blob) { el.dataset.personalizedImage=blob;el.dataset.personalizedNote='Your uploaded photo. This is a photo layout, not the finished AI portrait.';document.dispatchEvent(new Event('ppp:preview-update')); }
    }
    setTimeout(init,100);
  },true);
  ['variant:update','variant:selected','shopify:section:load'].forEach(function (name) { document.addEventListener(name,init); });
  document.addEventListener('submit',render,true);
  document.addEventListener('click',function (e) { if (e.target.closest('[type="submit"], [name="add"]')) render(); },true);
  // Easify adds hidden line properties after upload, outside its input change event.
  setInterval(function () { if (!document.hidden) init(); },1000);
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
